import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import ACSelect from './ACSelect';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import styles from './ACMedia.module.scss';

export default class ACMedia extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidYouTubeVideoUrl: true,
    };
  }

  onChangeVideoUrl = (e) => {
    const {
      videoRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})?$/,
    } = this.props;

    if (isEmpty(e)) return;

    const { value = '' } = e.target;

    const isMatched = value.match(videoRegex);

    if (isMatched || isEmpty(value)) this.setState({ isValidYouTubeVideoUrl: true });
    else this.setState({ isValidYouTubeVideoUrl: false });

    this.props.onChangeVideoUrlFunc(e);
  };

  renderMediaIMG(imgUrl) {
    if (imgUrl) {
      return (
        <img
          alt="photo_media"
          src={imgUrl}
          style={{
            maxWidth: 300,
            display: 'flex',
            margin: 'auto',
          }}
        />
      );
    }
  }

  renderUpload() {
    const {
      name,
      media = {},
      adornment = styles.adornment,
      onUploadMediaFunc,
      onClearMediaFunc,
      onChangeMediaUrlFunc,
      accept = 'image/*,audio/*',
    } = this.props;

    const { url = '', type } = media;
    const acceptByType = type === 'image' ? 'image/*' : type === 'audio' ? 'audio/*' : accept;

    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={adornment}>
                Media
              </InputAdornment>
            ),
          }}
          value={url}
          onChange={onChangeMediaUrlFunc}
          className={styles.textField}
        />
        <label
          htmlFor="clear-asset"
          style={{
            float: 'right',
            background: 'rgb(211, 47, 47)',
            marginTop: 'auto',
            marginRight: '5px',
          }}
        >
          <Button
            component="span"
            style={{
              color: 'white',
            }}
            onClick={onClearMediaFunc}
          >
            Clear
          </Button>
        </label>
        <input
          id={name}
          type="file"
          style={{ display: 'none' }}
          accept={acceptByType}
          onChange={onUploadMediaFunc}
        />
        <label
          htmlFor={name}
          style={{
            float: 'right',
            background: 'rgb(82, 168, 239)',
            marginTop: 'auto',
          }}
        >
          <Button
            component="span"
            style={{
              color: 'white',
            }}
          >
            Upload
          </Button>
        </label>
      </div>
    );
  }

  renderVideoUrlInput() {
    const { media = {}, adornment = styles.adornment } = this.props;
    const { isValidYouTubeVideoUrl = true } = cloneDeep(this.state);

    const { type = '', url = '' } = media;
    if (type !== 'video') return null;

    return (
      <div
        style={{
          display: 'flex',
        }}
      >
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={adornment}>
                Video Url
              </InputAdornment>
            ),
          }}
          value={url}
          onChange={this.onChangeVideoUrl}
          className={
            isValidYouTubeVideoUrl
              ? styles.textField
              : [styles.textField, styles.textFieldError].join(' ')
          }
        />
      </div>
    );
  }

  render() {
    const { media = {}, onChangeMediaTypeFunc, isMediaTypeDisabled = false } = this.props;

    const { type = '', url = '' } = media;

    const mediaTypes = [
      { label: 'Image', value: 'image' },
      { label: 'Audio', value: 'audio' },
      { label: 'Video', value: 'video' },
    ];
    const mediaType = mediaTypes.find((mediaType) => {
      return mediaType.value === type;
    });

    return (
      <div>
        {type === 'image' ? this.renderMediaIMG(url) : ''}
        <ACSelect
          name="type"
          options={mediaTypes}
          option={mediaType}
          optionLabel="label"
          optionValue="value"
          label="Media Type"
          onChangeFunc={onChangeMediaTypeFunc}
          isDisabled={isMediaTypeDisabled}
        />
        {type === 'image' || type === 'audio' ? this.renderUpload() : this.renderVideoUrlInput()}
      </div>
    );
  }
}
